import { UserLanguage } from '../../features/account/types/User'

export enum InternalTagType {
  Game = 'game',
  Feature = 'feature',
  Implementation = 'implementation',
  Chapter = 'chapter',
  Brand = 'brand',
  Concept = 'concept',
  Event = 'event',
  EventSecondary = 'event-secondary',
  Report = 'report',
}

export type InternalTagTranslation = { name: string; description: string; imageText: string }

export type InternalTagTranslations = Record<UserLanguage, InternalTagTranslation>

export type InternalTag = {
  id: string
  name: string
  type: InternalTagType
  active?: boolean
  order?: number
  description?: string | null
  imageUrl?: string | null
  imageText?: string | null
  // Feature tags target feature `legacyId`s; the other types target choice `weightId`s.
  targets?: number[]
  divider?: boolean
  translations?: InternalTagTranslations | null
  createdAt?: number
  modifiedAt?: number
  createdBy?: string | null
  modifiedBy?: string | null
  [key: string]: unknown
}

export type InternalConcept = {
  id: string
  conceptId: number
  featureTagId: string | null
  tags: string[]
  screenshotIds: string[]
  [key: string]: unknown
}

export type InternalTagSaveBody = {
  tag: Partial<InternalTag> & { name: string; type: InternalTagType; translations: InternalTagTranslations | null }
  concept?: Partial<InternalConcept> & { featureTagId: string | null }
}

export type InternalTagImplementations = {
  games: Record<string, string[]>
  features: Record<string, string[]>
}

export type InternalTagOrder = Record<string, number>

// Target ids per tag id: feature `legacyId`s for feature tags, choice `weightId`s for game tags.
export type InternalTagTargets = Record<string, number[]>
